//https://boost.allnetru.dev/api/documentation#/Payment
import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetOpenStripeResponse,
  GetUserBillingPaymentsResponse,
  PostBillingMethodIdResponse,
  PostDefaultBillingMethodIdResponse,
} from './models';
import { baseQueryWithReauth } from '../baseQueryWithReauth';

const payment = `payment`;

export const paymentApi = createApi({
  reducerPath: payment,
  baseQuery: baseQueryWithReauth,
  tagTypes: [payment],
  endpoints: (build) => ({
    getUserBillingPayments: build.query<GetUserBillingPaymentsResponse, void>({
      query: () => ({
        url: '/billing/payment',
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      providesTags: [{ type: payment, id: 'LIST' }],
    }),

    // STRIPE
    getOpenStripe: build.query<GetOpenStripeResponse, void>({
      query: () => ({
        url: '/billing/payment/setupIntent',
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
    }),
    postBillingMethodId: build.mutation<PostBillingMethodIdResponse, { id: string }>({
      query: ({ id }) => ({
        method: 'POST',
        url: `/billing/payment/${id}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [{ type: payment, id: 'LIST' }],
    }),
    deleteBillingMethodId: build.mutation<void, { id: string }>({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `/billing/payment/${id}`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [{ type: payment, id: 'LIST' }],
    }),
    postDefaultBillingMethodId: build.mutation<PostDefaultBillingMethodIdResponse, { id: string }>({
      query: ({ id }) => ({
        method: 'POST',
        url: `/billing/payment/${id}/default`,
        headers: {
          Accept: 'application/json', // Specify JSON response
        },
      }),
      invalidatesTags: [{ type: payment, id: 'LIST' }],
    }),
  }),
});

export const {
  useGetUserBillingPaymentsQuery,
  useLazyGetUserBillingPaymentsQuery,
  useLazyGetOpenStripeQuery,
  usePostBillingMethodIdMutation,
  useDeleteBillingMethodIdMutation,
  usePostDefaultBillingMethodIdMutation,
} = paymentApi;
